export default __webpack_public_path__ + "static/media/spice.e2f33124.jpg";